// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-embed-block {
  margin-bottom: 15px;
  padding: 12px 16px;
}
.skeleton-embed-block__bar {
  margin-bottom: 12px;
}
.skeleton-embed-block__bar ion-skeleton-text {
  width: 50%;
  height: 20px;
  margin: 0;
  border-radius: 4px;
}
.skeleton-embed-block__body ion-skeleton-text {
  width: 100%;
  height: 180px;
  margin: 0;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/embdedded/skeleton-embed-block/skeleton-embed-block.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACN;AAII;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AAFN","sourcesContent":[".skeleton-embed-block {\n  margin-bottom: 15px;\n  padding: 12px 16px;\n\n  &__bar {\n    margin-bottom: 12px;\n\n    ion-skeleton-text {\n      width: 50%;\n      height: 20px;\n      margin: 0;\n      border-radius: 4px;\n    }\n  }\n\n  &__body {\n    ion-skeleton-text {\n      width: 100%;\n      height: 180px;\n      margin: 0;\n      border-radius: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
